// CardRoutes.js
import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";
import TaxesList from "../components/DealerManagement/Admin/LogisticsManagement/Taxes";
import AddTaxes from "../components/DealerManagement/Admin/LogisticsManagement/Taxes/AddTaxes";
import HsncodeList from "../components/DealerManagement/Admin/LogisticsManagement/HSNCode";
import AddHsnCode from "../components/DealerManagement/Admin/LogisticsManagement/HSNCode/AddHsnCode";
import TaxsetList from "../components/DealerManagement/Admin/LogisticsManagement/Taxset";
import AddTaxset from "../components/DealerManagement/Admin/LogisticsManagement/Taxset/AddTaxset";
import UnitList from "../components/DealerManagement/Admin/LogisticsManagement/Unit";
import AddUnit from "../components/DealerManagement/Admin/LogisticsManagement/Unit/AddActionToBeTaken";
//import VendorAdd from "../components/DealerManagement/Admin/LogisticsManagement/VenderType/VendorAdd";
import PaymentTerms from "../components/DealerManagement/Admin/LogisticsManagement/PaymentTerm";
import AddPaymentTerms from "../components/DealerManagement/Admin/LogisticsManagement/PaymentTerm/AddPaymentTerms";
import PartCategory from "../components/DealerManagement/Admin/LogisticsManagement/PartCategory";
import AddPartCategory from "../components/DealerManagement/Admin/LogisticsManagement/PartCategory/AddPartCategory";
import Logistics from "../components/DealerManagement/Logistics";
import AddLogisticsLists from "../components/DealerManagement/Logistics/AddLogisticsLists";
import AddVehicleDetails from "../components/DealerManagement/Logistics/LogisticsComponents/AddVehicleDetails";
import AddSpareParts from "../components/DealerManagement/Logistics/LogisticsComponents/AddSpareParts";
import AddAccessories from "../components/DealerManagement/Logistics/LogisticsComponents/AddAccessories";
import PurchaseOrder from "../components/DealerManagement/Logistics/PurchaseOrder";
import CreateNewPurchaseOrder from "../components/DealerManagement/Logistics/PurchaseOrder/AddPurchaseOrder";
import POApproval from "../components/DealerManagement/Logistics/PO Approval";
import AddPoApproval from "../components/DealerManagement/Logistics/PO Approval/AddPoApproval";
import StockDetails from "../components/DealerManagement/Logistics/StockDetails";
import StockIn from "../components/DealerManagement/Logistics/StockIn";
import StockOut from "../components/DealerManagement/Logistics/StockOut";
import EditHsnCode from "../components/DealerManagement/Admin/LogisticsManagement/HSNCode/EditHSNCode";
import EditTaxes from "../components/DealerManagement/Admin/LogisticsManagement/Taxes/EditTaxes";
import EditUnit from "../components/DealerManagement/Admin/LogisticsManagement/Unit/EditUnit";
import VendorTypeEdit from "../components/DealerManagement/Admin/LogisticsManagement/VenderType/EditVendorType";
import VendorEdit from "../components/DealerManagement/Admin/LogisticsManagement/Vender/EditVendor";
import EditPaymentTerms from "../components/DealerManagement/Admin/LogisticsManagement/PaymentTerm/EditPaymentTerm";
import EditPartCategory from "../components/DealerManagement/Admin/LogisticsManagement/PartCategory/EditPartCategory";
import VendorTypeList from "../components/DealerManagement/Admin/LogisticsManagement/VenderType";
import VendorList from "../components/DealerManagement/Admin/LogisticsManagement/Vender";
import VendorAdd from "../components/DealerManagement/Admin/LogisticsManagement/Vender/VendorAdd";
import VendorTypeAdd from "../components/DealerManagement/Admin/LogisticsManagement/VenderType/VendorAdd";
import PhysicalStockTaking from "../components/DealerManagement/Logistics/PhysicalStockTaking";
import OrderReceivedRequest from "../components/DealerManagement/Logistics/OrderReceivedRequest";
import CreatePhysicalStockTaking from "../components/DealerManagement/Logistics/PhysicalStockTaking/AddPhysicalStockTaking";
import UpdatePhysicalStockTaking from "../components/DealerManagement/Logistics/PhysicalStockTaking/EditPhysicalStockTaking";
import PhysicalStockingDetails from "../components/DealerManagement/Logistics/PhysicalStockTaking/PhysicalStockingDetails";
import LogisticsDashboard from "../components/DealerManagement/Logistics/Dashboard";
import PurchaseOrderDetails from "../components/DealerManagement/Logistics/PurchaseOrder/PurchaseOrderDetails";
import PoApprovalDetails from "../components/DealerManagement/Logistics/PO Approval/PoApprovalDetails";
import OrderRecivedRequestDetails from "../components/DealerManagement/Logistics/OrderReceivedRequest/OrderReceivedRequestDetails";
import ReceiptList from "../components/DealerManagement/Logistics/Receipt/ReceiptList";
import ReceiptDetails from "../components/DealerManagement/Logistics/Receipt/ReceiptDetails";
import PartSpecific from "../components/DealerManagement/Logistics/PurchaseOrder/PartSpecific";
import StockInDetails from "../components/DealerManagement/Logistics/StockIn/StockinDetails";
import StockOutDetails from "../components/DealerManagement/Logistics/StockOut/StockOutDetails";
//import Dashboard from "../components/DealerManagement/Admin/Dashboard/"
// import VendorEdit from "../components/DealerManagement/Admin/LogisticsManagement/VenderType/EditVendorType";


const LogisticsRoutes = () => {
  return (
    <>
    <Route
        path={ROUTES_NAVIGATION.LOGISTICDASHBOARD}
        element={<LogisticsDashboard />}
      />

    <Route 
    path={ROUTES_NAVIGATION.LOGISTICMAINDASHBOARD }
    element={ <LogisticsDashboard/> }
    />  

      <Route
        path={ROUTES_NAVIGATION.TAXESLIST}
        element={<TaxesList />}
      />
      <Route
        path={ROUTES_NAVIGATION.TAXES_ADD}
        element={<AddTaxes />}
      />

      <Route
        path={ROUTES_NAVIGATION.HSNCODELIST}
        element={<HsncodeList />}
      />
      <Route
        path={ROUTES_NAVIGATION.HSNCODE_ADD}
        element={<AddHsnCode />}
      />

      <Route
        path={ROUTES_NAVIGATION.TAXSETLIST}
        element={<TaxsetList />}
      />
      <Route
        path={ROUTES_NAVIGATION.TAXSETADD}
        element={<AddTaxset />}
      />
      <Route 
      path={ROUTES_NAVIGATION.UNIT}
      element={<UnitList />}
      />
      <Route 
      path={ROUTES_NAVIGATION.UNITADD}
      element={<AddUnit/>}
      />
      <Route 
      path={ROUTES_NAVIGATION.VENDORTYPELIST}
      element={<VendorTypeList />}
      />
      <Route
      path={ROUTES_NAVIGATION.VENDORADD}
      element={<VendorAdd />}
      />
      <Route 
      path={ROUTES_NAVIGATION.VENDORLIST}
      element={<VendorList/>}
      />
      <Route
      path={ROUTES_NAVIGATION.VENDORTYPEADD}
      element={<VendorTypeAdd />}
      />
      <Route 
      path={ROUTES_NAVIGATION.PAYMENTLISTS}
      element={<PaymentTerms/>}
      />
      <Route
      path={ROUTES_NAVIGATION.PAYMENTADDTERMS}
      element={ <AddPaymentTerms/> }
      />
      <Route 
      path={ROUTES_NAVIGATION.PARTCATEGORYLISTS}
      element={ <PartCategory/> }
      />
      <Route 
      path={ROUTES_NAVIGATION.ADDPARTCATEGORY}
      element={<AddPartCategory />}
      />
     

      <Route 
      path={ROUTES_NAVIGATION.LOGISTICS}
      element={<Logistics /> }
      />
      <Route 
      path={ROUTES_NAVIGATION.ADDLOGISTICS}
      element={ <AddLogisticsLists /> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDVEHICLEDETAILS}
      element={ <AddVehicleDetails/> }
      />

      <Route 
      path= {ROUTES_NAVIGATION.ADDSPAREPARTS}
      element={ <AddSpareParts/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDACCESSORIES}
      element={<AddAccessories />}
      />

      <Route 
      path={ROUTES_NAVIGATION.PURCHASEORDER}
      element={ <PurchaseOrder /> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDPURCHASEORDER}
      element={ <CreateNewPurchaseOrder/> }
      />

<Route 
      path={ROUTES_NAVIGATION.UPDATEPURCHASEORDER}
      element={ <CreateNewPurchaseOrder/> }
      />
      <Route 
      path={ROUTES_NAVIGATION.PURCHASEORDERDETAILS}
      element={ <PurchaseOrderDetails /> }
      />
       <Route 
      path={ROUTES_NAVIGATION.PARTSPECIFIC}
      element={ <PartSpecific /> }
      />

      <Route 
      path={ROUTES_NAVIGATION.POAPPROVAL}
      element={ <POApproval/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDPOAPPROVAL}
      element={ <AddPoApproval/> }
      />

      <Route 
      path={ ROUTES_NAVIGATION.POAPPROVALDETAILS }
      element={ <PoApprovalDetails/> }
      />
      <Route 
      path={ ROUTES_NAVIGATION.ORDERRECIVEDREQUESTDETAILS }
      element={ < OrderRecivedRequestDetails/> }
      />


      <Route 
      path={ROUTES_NAVIGATION.STOCKDETAILS}
      element={<StockDetails/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.STOCKIN}
      element={ <StockIn/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.STOCKINDETAILS}
      element={ <StockInDetails/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.STOCKOUT}
      element={ <StockOut/> }
      />
       <Route 
      path={ROUTES_NAVIGATION.STOCKOUTDETAILS}
      element={ <StockOutDetails/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.STOCKTAKING}
      element={ <PhysicalStockTaking/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDPHYSICALSTOCKTAKING}
      element={ <CreatePhysicalStockTaking/> }
      />

      <Route
      path={ROUTES_NAVIGATION.EDITPHYSICALSTOCKTAKING}
      element={ <UpdatePhysicalStockTaking /> }
      />

      <Route 
      path={ ROUTES_NAVIGATION.PHYSICALSTOCKTAKINGDETAILS }
      element={ <PhysicalStockingDetails/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ORDERREQUEST}
      element={ <OrderReceivedRequest/> }
      />

<Route 
      path={ROUTES_NAVIGATION.RECEIPTLIST}
      element={ <ReceiptList/> }
      />
      <Route 
      path={ROUTES_NAVIGATION.RECEIPTDETAILS}
      element={ <ReceiptDetails /> }
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITHSNCODE}
      element={ <EditHsnCode/> }
      />

      <Route 
      path={ ROUTES_NAVIGATION.EDITTAXES }
      element={ <EditTaxes /> }
      />

      <Route 
      path={ROUTES_NAVIGATION.UNITEDIT}
      element={ <EditUnit/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.VENDOREDIT}
      element={ <VendorEdit/> }
      />
        <Route 
      path={ROUTES_NAVIGATION.VENDORTYPEEDIT}
      element={ <VendorTypeEdit/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.PAYMENTTERMSEDIT}
      element={ <EditPaymentTerms/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITPARTCATEGORY}
      element={ <EditPartCategory/> }
      />

   
      

    </>
  );
};

export default LogisticsRoutes;
